/**
 * @file enum
 * @author dengqianchuan@baidu.com
 */

export const showPartnerNum = 3;
// eslint-disable-next-line
export const emojiRegExp = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/;

export const StatusText = {
    0: '未开始',
    1: '提前入会',
    2: '进行中',
    3: '会议锁定',
    4: '人数已满',
    5: '会议结束',
    6: '会议取消'
};

export const DurationText = [
    {
        value: 30,
        text: '30' + '分钟'
    },
    {
        value: 60,
        text: '60' + '分钟'
    },
    {
        value: 90,
        text: '90' + '分钟'
    },
    {
        value: 120,
        text: '120' + '分钟'
    },
    {
        value: 180,
        text: '180' + '分钟'
    }
];

export const SESSION_KEY = '_RTC_MEETING';
